export const cardActionsStyles = {
	boostButton: 'min-w-[147px] whitespace-nowrap'
} as const;
